import TextField from '@mui/material/TextField';
import { Paper } from '@mui/material';

const RegistrationChildResidentialInfo = ({
  childObject,
  updateChild,
  validation,
}) => {
  const handleFormChange = e => {
    updateChild(e.target);
  };

  return (
    <Paper elevation={5} sx={{ padding: '20px' }}>
      {/* <TextField
        required
        fullWidth
        multiline
        error={validation.address}
        helperText={validation.address && 'Please enter your street address'}
        label='Residential Address'
        rows='3'
        margin='dense'
        name='address'
        value={childObject['address']}
        onChange={handleFormChange}
        inputProps={{ 'data-cy': 'child-address' }}
        id='child-address'
      ></TextField>
      <TextField
        fullWidth
        label='Unit Number'
        margin='dense'
        name='address_unit'
        value={childObject['address_unit']}
        onChange={handleFormChange}
        inputProps={{ 'data-cy': 'child-unit' }}
        id='child-unit'
      ></TextField> */}
      <TextField
        required
        error={validation.address_postal}
        helperText={
          validation.address_postal && 'Please enter your postal code'
        }
        fullWidth
        label='Postal Code'
        margin='dense'
        name='address_postal'
        value={childObject['address_postal']}
        onChange={handleFormChange}
        inputProps={{ 'data-cy': 'child-postal' }}
        id='child-postal'
      ></TextField>
    </Paper>
  );
};

export default RegistrationChildResidentialInfo;
